import React from "react";

function AccordionOne() {
	return (
		<div className="flex flex-col items-center text-center">
			<p className="text-3xl mb-4">
			Find Out What’s in Your Water – Schedule Your Free Consultation Today!
			</p>
			<p className="text-xl mb-12">
			We’ll help you understand your water quality and find the best solution for your home. No pressure, just expert advice!
			</p>
			<div className="flex flex-col items-center">
				<div className="hidden sm:flex flex-col text-gray-800 items-center">
					<a href="tel:+19512125633" className="hover:text-red-700 hover:underline text-lg">
						<i className="fas fa-phone mr-2"></i>
						+1 (951) 212-5633
					</a>
					<a href="mailto:Polarwaterllc@gmail.com" className="hover:text-red-700 hover:underline text-lg mt-2">
						<i className="fas fa-envelope mr-2"></i>
						Polarwaterllc@gmail.com
					</a>
				</div>
				<div className="flex sm:hidden flex-col text-gray-800 items-center mt-5">
					<a href="tel:+19512125633" className="text-red-700 hover:underline text-lg">
						<i className="fas fa-phone mr-2"></i>
						+1 (951) 212-5633
					</a>
					<a href="mailto:Polarwaterllc@gmail.com" className="text-red-700 hover:underline text-lg mt-2">
						<i className="fas fa-envelope mr-2"></i>
						Polarwaterllc@gmail.com
					</a>
				</div>
			</div>
		</div>
	);
}

export default AccordionOne;
